
$(".navbtn").click(function () {//ボタンがクリックされたら
$(this).toggleClass('active');//ボタン自身に activeクラスを付与し
    $("#nav, body").toggleClass('open');//ナビゲーションにopenクラスを付与
});

$("#nav a").click(function () {//ナビゲーションのリンクがクリックされたら
    $(".navbtn").removeClass('active');//ボタンの activeクラスを除去し
    $("#nav, body").removeClass('open');//ナビゲーションのopenクラスを付与クラスも除去
});
